import { render, staticRenderFns } from "./AgentManagement.vue?vue&type=template&id=454361b8&scoped=true"
import script from "./AgentManagement.vue?vue&type=script&lang=js"
export * from "./AgentManagement.vue?vue&type=script&lang=js"
import style0 from "./AgentManagement.vue?vue&type=style&index=0&id=454361b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454361b8",
  null
  
)

export default component.exports